import type { Collaborator, Collaborators, CrossJoinIntegration } from '../../common/types';
import type { CollaborationGraphEntities, CollaborationGraphEntity } from '../types';

const COLLABORATION_GRAPH_MAX_RESULTS = 50;

export const getUsersFromCollaborationGraph = async (
	integration: CrossJoinIntegration,
	cloudId: string,
	userId: string,
): Promise<Collaborators> => {
	const payload = {
		context: {
			contextType: integration,
			principalId: userId,
			siteId: cloudId,
		},
		modelRequestParams: {
			experience: 'CgUserNearbyUser',
		},
		expanded: true,
		maxNumberOfResults: COLLABORATION_GRAPH_MAX_RESULTS,
		userId,
	};

	const response = await fetch('/gateway/api/collaboration/v1/collaborationgraph/user/user', {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(payload),
	});

	const result = ((await response.json()) as CollaborationGraphEntities)?.collaborationGraphEntities
		?.filter(
			(en): en is CollaborationGraphEntity & { userProfile: Collaborator } =>
				en?.userProfile !== undefined &&
				en?.userProfile?.account_type !== 'app' &&
				en?.userProfile?.account_status !== 'deactivated' &&
				en?.userProfile?.account_status !== 'deleted',
		)
		.map(({ userProfile: { account_id, name, picture } }) => ({
			id: account_id,
			name,
			avatar: picture,
		}));
	return result;
};
